import { z } from 'my-zod'
import { taxPolicyModel } from './tax-policy-model'

export const taxPolicyUpdate = taxPolicyModel
  .pick({
    category: true,
    unit: true,
    amount: true,
    outfitterId: true,
    title: true,
    beginDate: true,
    endDate: true
  })
  .extend({
    title: z.string().trim().max(256).min(1, { message: 'Required' }),
    id: z.number().optional()
  })

export type taxPolicyUpdate = z.infer<typeof taxPolicyUpdate>
